import { type LucideIcon, Zap } from "lucide-react";
import { isEmojiIcon, resolveIconKey } from "@/lib/icons";

interface IconRendererProps {
  iconKey?: string | null;
  fallback?: LucideIcon;
  className?: string;
  emojiClassName?: string;
}

export function IconRenderer({
  iconKey,
  fallback = Zap,
  className = "h-5 w-5",
  emojiClassName = "text-2xl leading-none",
}: IconRendererProps) {
  if (isEmojiIcon(iconKey)) {
    return <span className={emojiClassName} aria-hidden="true">{iconKey}</span>;
  }

  const Icon = resolveIconKey(iconKey, fallback);
  return <Icon className={className} aria-hidden="true" />;
}